import { useShopWebview } from "_common/hooks/useShopWebview";
import Presentation       from "./presentation";
import toast              from "_common/toast";

const component = props => {

	const {
		updateShopLink,
		productURL
	} = useShopWebview ( {
		productId: props?.data?._id
	} );

	function handleOnClick ( e ) {
		const input = window.prompt ( "Choose one of the shop env to use:\n 'prod' or 'stage' or 'localhost'" );

		if ( [ "prod", "stage", "localhost" ].includes ( input ) ) {
			updateShopLink ( input );
		} else {
			toast.error ( "Please enter correct value" );
			e.preventDefault ();
		}
	}

	return (
		<Presentation
			data = { props?.data }
			handleOnClick = { handleOnClick }
			isLoading = { props?.isLoading }
			productURL = { productURL }
		/>
	);
};

export default component;